import { render } from "./AppSectionIcon.vue?vue&type=template&id=12584a28&scoped=true&ts=true&lang=pug"
import script from "./AppSectionIcon.vue?vue&type=script&lang=ts"
export * from "./AppSectionIcon.vue?vue&type=script&lang=ts"

import "./AppSectionIcon.vue?vue&type=style&index=0&id=12584a28&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12584a28"]])

export default __exports__